import axios from "axios";

export default axios.create({
    baseURL: "https://app.ecoraapp.com:8092/api", //"https://app.ecoraapp.com:8092/api", //With cors app.ecoraapp.com https://app.ecoraapp.com:8092/api
    headers: {
        "Content-type": "application/json"
    }
});